/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    background: '#005a87',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fieldListHeader: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginBottom: '15px'
  },
  fieldList: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(0.5),
      // width: '21em',
    },
    '& > p': {
      alignItems: 'left',
      width: '20px',
    },
  },
  buttonAdd: {
    background: '#32cd32',
    margin: theme.spacing(0.5),
    color: 'white',
  },
  buttonDelete: {
    background: '#1B1B1B',
    margin: theme.spacing(0.5),
    color: 'white',
  },
  addRow: {
    background: '#FFA500',
    margin: theme.spacing(0.5),
    color: 'white',
  },
  margin: {
    margin: theme.spacing(0.5),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}))